// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import { bindHandler } from '../../utils';
import * as Styles from './ThumbnailNavigatorWidget.scss';
export default function ThumbnailNavigatorWidget(props) {
    useStyles(Styles);
    const { items, handleSelected } = props;
    return (React.createElement("div", { className: Styles.thumbnailNavigator },
        props.header && (React.createElement("div", null,
            React.createElement("h1", { className: "music-headline-4" }, props.header))),
        React.createElement("div", { className: Styles.thumbnailGrid }, items.map((item, index) => (React.createElement("music-thumbnail-item", { id: `thumbnailNavigatorButton${index + 1}`, backgroundImage: item.backgroundImage, onClick: bindHandler(handleSelected, null, item.primaryLink.onItemSelected), primaryText: item.mainText, role: "button" }))))));
}
